angular.module('iqxCore')
	.controller('ClientCurrentRequirementsCtrl', function ($scope, FormSvc, ApiSvc, ActionDialogLegacySvc, SweetAlert, $routeParams, $location) {
		if (!$scope.checkPermissions('CLIENT')) {
			return
		}

		$scope.addShifts = function () {
			$location.path("/currentrequirements/addshifts")
		}

		/* Vars */
		moment.locale('en_gb', {
			week: {
				dow: 1
			}
		})
		$scope.viewDateFilter = false
		$scope.useRefInsteadOfQty = $scope.userHasRight('REQUIREMENTSBULK')
		$scope.currentRequirements = [{}]
		$scope.selects = {}
		$scope.showButton = false
		$scope.requirementAdded = false
		$scope.isSV = false
		$scope.isCV = false
		$scope.isPV = false
		$scope.isBulk = false
		if ($scope.params.CLIENTREQDATEFROM && $scope.params.CLIENTREQDATETO) {
			$scope.datefilter = {
				"from": moment().subtract($scope.params.CLIENTREQDATEFROM, 'days').toDate(),
				"to": moment().add($scope.params.CLIENTREQDATETO, 'days').toDate()
			}
		} else {
			$scope.datefilter = {
				"from": moment().subtract(1, 'week').toDate(),
				"to": moment().add(1, 'year').toDate()
			}
		}
		$scope.bulkday = {
			"monday": {
				"checked": true,
				"number": 1
			},
			"tuesday": {
				"checked": true,
				"number": 1
			},
			"wednesday": {
				"checked": true,
				"number": 1
			},
			"thursday": {
				"checked": true,
				"number": 1
			},
			"friday": {
				"checked": true,
				"number": 1
			},
			"saturday": {
				"checked": true,
				"number": 1
			},
			"sunday": {
				"checked": true,
				"number": 1
			}
		}
		$scope.toggleAddBulkShifts = false

		$scope.guid = function (modifier) {
			var S4 = function () {
				return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
			}
			return (modifier + "_" + S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4())
		}
		$scope.openDatePopup = function (event, reqID) {
			event.preventDefault()
			event.stopPropagation()
			$scope.requirementsObj[reqID].open = true
		}

		$scope.requirementsObj = [{
			'entry': '1',
			'break': 0,
			'open': false,
			'guid': $scope.guid('date')
		}]
		$scope.selectedAll = false

		$scope.datefilter.statusOptions = [{'Value': '%', 'Descrip': 'All'}]

		$scope.statusOptions = function () {
			var datefilter = {
				"from": moment().subtract(1, 'year').toDate(),
				"to": moment().add(1, 'year').toDate()
			}
			var includeCancelled = ($scope.datefilter.incCancelled ? 1 : 0)
			var searchstring = ('')
			var filledStatus = ('')
			$scope.viewDateFilter = false
			FormSvc.setOptions($scope, {
				fetchAPI: `callresult/NetClientRequirementList?pIncCancelled=${includeCancelled}&pStartDate=${moment(datefilter.from).format("YYYY-MM-DD")}&pEndDate=${moment(datefilter.to).format("YYYY-MM-DD")}${searchstring}${filledStatus}`,
				multiRow: true,
				fetchTarget: "requirementList",
				sliceSize: 200000,
				autoEdit: true
			})
			return $scope.fetch()
				.then(function () {
					angular.forEach($scope.requirementList, function (value){
						if ($scope.datefilter.statusOptions.find(function(element){
								return element.Value === value.TextStatus
							}) === undefined){
								$scope.datefilter.statusOptions.push(
									{'Value': value.TextStatus, 'Descrip': value.TextStatus}
								)
						}
					})
				})
		}
		$scope.statusOptions()


		// New Bulk Add Requirements Functions

		$scope.submitReqList = function (addAnother) {
			var addAnother = addAnother || false
			$scope.currentRequirements = $scope.requirementsObj
			$scope.sendShifts(addAnother)
		}

		$scope.removeReqRowSelected = function (row) {
			$scope.requirementsObj[row]['selected'] = true
			var newDataList = []
			$scope.selectedAll = false
			angular.forEach($scope.requirementsObj, function (selected) {
				if (!selected.selected) {
					newDataList.push(selected)
				}
			})
			$scope.requirementsObj = newDataList
		}

		$scope.removeReqRow = function () {
			var newDataList = []
			$scope.selectedAll = false
			angular.forEach($scope.requirementsObj, function (selected) {
				if (!selected.selected) {
					newDataList.push(selected)
				}
			})
			$scope.requirementsObj = newDataList
		}

		$scope.reqCheckAll = function () {
			angular.forEach($scope.requirementsObj, function (req) {
				req.selected = $scope.selectedAll
			})
		}

		$scope.addReqRow = function (requirementsObj) {
			$scope.requirementsObj.push({
				'entry': 1,
				'guid': $scope.guid("date"),
				'open': false,
				'selected': '',
				'date': '',
				'type': '',
				'from': '',
				'to': '',
				'break': 0,
				'qty': '',
				'note': ''
			})
		}

		$scope.checkRowIsValid = function (r) {
			$scope.problem = ''

			if (!r.date) { return false } // No Date
			if (!r.type) { return false } // No Type
			if (!r.from) { return false } // No From Time
			if (!r.to) { return false } // No To Time
			if (r.break == '') { return false } // Break is empty
			if (!r.qty || r.qty == 0) { return false } // Quantity is 0 or empty
			if (!r.note) { return false } // No Note

			// All Good!
			return true
		}

		$scope.checkRow = function (row) {
			if ($scope.checkRowIsValid(row)) {
				row.isValid = true
			} else {
				row.isValid = false
			}
		}

		$scope.cloneReqRow = function (reqObj, increment) {
			var valid = $scope.checkRowIsValid(reqObj)

			if (valid) {
				increment = increment || 0
				var x = angular.copy(reqObj)
				x.date = moment(x.date).add(increment, 'days').toDate()
				$scope.requirementsObj.push(x)
			} else {
				FormSvc.alert("Invalid Row", "You can't duplicate an invalid row.", "warning")
			}
		}

		$scope.shiftTemplateSelect = function (req) {
			req.from = req.template.TimeFrom
			req.to = req.template.TimeTo
			req.break = req.template.BreakMinutes
			req.fixed = !req.template.Moveable
			req.type = req.template.LineID
		}

		$scope.toggleAddBulkShift = function () {
			$scope.toggleAddBulkShifts = !$scope.toggleAddBulkShifts
		}

		$scope.bulkChangeDays = function (s) {
			switch (s) {
				case 'mon-fri':
					$scope.bulkday.monday.checked = true
					$scope.bulkday.tuesday.checked = true
					$scope.bulkday.wednesday.checked = true
					$scope.bulkday.thursday.checked = true
					$scope.bulkday.friday.checked = true
					$scope.bulkday.saturday.checked = false
					$scope.bulkday.sunday.checked = false
					break

				case 'weekend':
					$scope.bulkday.monday.checked = false
					$scope.bulkday.tuesday.checked = false
					$scope.bulkday.wednesday.checked = false
					$scope.bulkday.thursday.checked = false
					$scope.bulkday.friday.checked = false
					$scope.bulkday.saturday.checked = true
					$scope.bulkday.sunday.checked = true
					break

				case 'everyday':
					$scope.bulkday.monday.checked = true
					$scope.bulkday.tuesday.checked = true
					$scope.bulkday.wednesday.checked = true
					$scope.bulkday.thursday.checked = true
					$scope.bulkday.friday.checked = true
					$scope.bulkday.saturday.checked = true
					$scope.bulkday.sunday.checked = true
					break

				default:
					$scope.bulkday.monday.checked = false
					$scope.bulkday.tuesday.checked = false
					$scope.bulkday.wednesday.checked = false
					$scope.bulkday.thursday.checked = false
					$scope.bulkday.friday.checked = false
					$scope.bulkday.saturday.checked = false
					$scope.bulkday.sunday.checked = false
					break
			}
		}

		$scope.showBulkAddShiftModal = function (isDupe) {
			$scope.isBulk = true
			if (isDupe) {
				angular.forEach($scope.currentRequirements, function (val, key) {
					if (!$scope.currentRequirements[key].added) {
						$scope.remove(key)
					}
				})
			}
			$scope.selects.$requirements = $scope.selects.requirements
			FormSvc.modalForm($scope, 'bulkaddRequirement', $scope.currentRequirements, 'md', { label: 'col-sm-2', data: 'col-sm-10' })
				.then(function (data) {
					for (var m = moment(data[0].Afromdate); m.diff(data[0].Atodate, 'days') <= 0; m.add(1, 'day')) {
						if ($scope.bulkday[m.format('dddd').toLowerCase()]['checked'] == true) {

							$scope.export = {}
							$scope.export[0] = {}
							$scope.export[0].break = data[0].break
							$scope.export[0].type = data[0].type
							$scope.export[0].ref = data[0].ref
							$scope.export[0].note = data[0].note

							$scope.export[0].from = data[0].from
							$scope.export[0].to = data[0].to

							$scope.export[0].date = moment(m).toDate()
							$scope.export[0].qty = $scope.bulkday[m.format('dddd').toLowerCase()]['number']

							$scope.export[0]['added'] = true
							$scope.export[0]['prettyDate'] = moment($scope.export[0].date).format("DD/MM/YYYY")
							$scope.export[0]['prettyTimeFrom'] = $scope.export[0].type.TimeFrom
							$scope.export[0]['prettyTimeTo'] = $scope.export[0].type.TimeTo

							if ($scope.selects.requirements.VacType == 'CV' || $scope.selects.requirements.VacType == 'PV') { // perm
								$scope.submitForm()
							} else { // shift
								$scope.requirementAdded = true
								$scope.currentRequirements.push($scope.export[0])
							}
						}
					}
				})
				.catch(function (err) {
					if (typeof err === 'undefined' || err == 'escape key press' || err == 'backdrop click') { // Escape Key pressed or backdrop cancel!
						$scope.resetForm()
					} else if (err && err != 'escape key press' && err != 'backdrop click') {
						FormSvc.alert("Error", err, "error")
					}
				})
		}

		$scope.getFilters = function () {
			return Promise.resolve()  // Short circuit until we decide what to do with this
		}

		$scope.putForwardCandidate = function (candidate, options) {
			switch (options) {
				case 'putforward':
					return ApiSvc.fetch(
						$scope,
						{
							fetchAPI: 'call/NetClientCandidateSubmit?pPersonID=' + candidate.PersonID + '&pLineID=' + $scope.activeRequirement.RowID + '&pIsShift=' + $scope.activeRequirement.IsShift,
							fetchTarget: 'putForwardCandidateRtrn',
							multiRow: false
						}
					)
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/NetClientRequirementShortList?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift,
									fetchTarget: 'ShortListed',
									multiRow: true
								}
							)
						})
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/NetClientRequirementShortListPlaced?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift + '&IsCurrent=Y',
									fetchTarget: 'PlacedCandidates',
									multiRow: true
								}
							)
						})
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/NetClientRequirementVerifiedCandidates?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift,
									fetchTarget: 'PreviousCandidates',
									multiRow: true
								}
							)
						})
						.then(function () {
							FormSvc.alert("Success", candidate.PersonName + " has been put forward for this position.", "success")
						})
					break

				case 'actionDialog':
					candidate.Rejected = true
					candidate.Requested = true
					candidate.PersonID = candidate.pPersonID
					candidate.PersonName = candidate.pName
					$scope.viewCandidate(candidate)
					break

				default:
					return FormSvc.modalInfo($scope, 'PutForwardModal', { candidate: candidate, choices: [{ desc: "Close", type: "primary", code: '' }] }, 'md')
					break
			}
		}

		$scope.filterRequirements = function () {
			var includeCancelled = ($scope.datefilter.incCancelled ? 1 : 0)
			var searchstring = ($scope.datefilter.SearchString ? '&pSearchString=' + $scope.datefilter.SearchString.replace('%', '|%').replace('_', '_%') : '')
			var filledStatus = ($scope.datefilter.FilledStatus ? '&pFillStatus=' + $scope.datefilter.FilledStatus : '')
			$scope.viewDateFilter = false
			FormSvc.setOptions($scope, {
				fetchAPI: `callresult/NetClientRequirementList?pIncCancelled=${includeCancelled}&pStartDate=${moment($scope.datefilter.from).format("YYYY-MM-DD")}&pEndDate=${moment($scope.datefilter.to).format("YYYY-MM-DD")}${searchstring}${filledStatus}`,
				multiRow: true,
				fetchTarget: "requirementList",
				sliceSize: 200000,
				autoEdit: true
			})
			return $scope.fetch()
				.then(function () {
					if ($scope.requirementList.length == 0 && $scope.filterLoaded) {
						FormSvc.alert("No Results", "Sorry, your filter does not match any requirements.", "info")
						$scope.filterLoaded = true
					} else {
						$scope.filterLoaded = true
					}
				})
		}

		$scope.duplicateWeek = function (key) {
			var date = moment($scope.currentRequirements[key].date).add(7, 'd').toDate()
			var prettydate = moment($scope.currentRequirements[key].date).add(7, 'd').format("DD/MM/YYYY")

			$scope.currentRequirements.push({
				'date': date,
				'type': $scope.currentRequirements[key].type,
				'from': moment($scope.currentRequirements[key].from).toDate(),
				'to': moment($scope.currentRequirements[key].to).toDate(),
				'break': $scope.currentRequirements[key].break,
				'qty': $scope.currentRequirements[key].qty,
				'note': $scope.currentRequirements[key].note,
				'ref': $scope.currentRequirements[key].ref,
				'added': false,
				'prettyDate': prettydate,
				'prettyTimeFrom': moment($scope.currentRequirements[key].from).format("HH:mm"),
				'prettyTimeTo': moment($scope.currentRequirements[key].to).format("HH:mm")
			})
			$scope.showAddShiftModal(true) // true == is dupe
		}

		$scope.duplicateDown = function (key, type) {
			switch (type) {
				case 'next':
					var date = moment($scope.currentRequirements[key].date).add(1, 'd').toDate()
					var prettydate = moment($scope.currentRequirements[key].date).add(1, 'd').format("DD/MM/YYYY")
					break

				case 'same':
					var date = moment($scope.currentRequirements[key].date).toDate()
					var prettydate = moment($scope.currentRequirements[key].date).format("DD/MM/YYYY")
					break
			}

			$scope.currentRequirements.push({
				'date': date,
				'type': $scope.currentRequirements[key].type,
				'from': moment($scope.currentRequirements[key].from).toDate(),
				'to': moment($scope.currentRequirements[key].to).toDate(),
				'break': $scope.currentRequirements[key].break,
				'qty': $scope.currentRequirements[key].qty,
				'note': $scope.currentRequirements[key].note,
				'ref': $scope.currentRequirements[key].ref,
				'added': false,
				'prettyDate': prettydate,
				'prettyTimeFrom': moment($scope.currentRequirements[key].from).format("HH:mm"),
				'prettyTimeTo': moment($scope.currentRequirements[key].to).format("HH:mm")
			})

			$scope.showAddShiftModal(true) // true == is dupe
		}

		$scope.refreshShortList = function () {
			$scope.faspinner = "fa-spin"

			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetClientRequirementShortList?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift,
					fetchTarget: 'ShortListed',
					multiRow: true
				}
			)
				.then(function () {
					return ApiSvc.fetch(
						$scope,
						{
							fetchAPI: 'callresult/NetClientRequirementShortListPlaced?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift + '&IsCurrent=Y',
							fetchTarget: 'PlacedCandidates',
							multiRow: true
						}
					)
				})
				.then(function () {
					return ApiSvc.fetch(
						$scope,
						{
							fetchAPI: 'callresult/NetClientRequirementVerifiedCandidates?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift,
							fetchTarget: 'PreviousCandidates',
							multiRow: true
						}
					)
				})
				.then(function () {
					$scope.faspinner = ""
				})
		}

		$scope.viewCandidate = function (candidate) {
			if (candidate.PersonID == '') {
				return
			}
			$scope.ShortlitedAcceptOrDecline = false
			/* Loads Limited Action Dialog for the client to view the candidates details */
			var obj = {
				linkID: candidate.PersonID, // Contains the ID of the person, vacancy, client etc...
				title: candidate.PersonName, // The Person, Vacancy or clients name
				companyID: $scope.activeRequirement.CompanyID,
				type: "Person" // Person, Vacancy, Client etc...
			}
			if (candidate.Rejected != true || candidate.Requested != true) {
				$scope.ShortlitedAcceptOrDecline = true
			} else {
				$scope.ShortlitedAcceptOrDecline = false
			}
			if (candidate.PersonStatus == "Placed" || candidate.PersonStatus == "Confirmed" || candidate.PersonStatus == "Worked" || candidate.PersonStatus == "Pending" || candidate.PersonStatus == "Current" || candidate.PersonStatus == "") {
				$scope.ShortlitedAcceptOrDecline = false
			}
			return ActionDialogLegacySvc.Actions($scope, 'show', '50', obj)
				.then(function () {
					return ApiSvc.fetch(
						$scope,
						{
							fetchAPI: 'callresult/NetClientRequirementShortList?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift,
							fetchTarget: 'ShortListed',
							multiRow: true
						}
					)
				})
		}

		$scope.viewOrBook = function (cand, choice = null) {
			if (!choice) {
				return FormSvc.modalInfo($scope, 'ViewBookShortlist', { candidate: cand, choices: [{ desc: "Cancel", type: "primary", code: '' }] }, 'md')
			} else {
				switch (choice) {
					case 'b': // book
						if ($scope.userHasRight('FILLJOBS')) {
							return $scope.bookCandidate(cand)
						} else {
							FormSvc.alert("Error", "You dont have permission to do that", "error")
						}
						break

					case 'v': //view
						return $scope.viewCandidate(cand)
						break

					case 's': //shortlist
						return $scope.putForwardCandidate(cand, 'putforward')
						break
				}
			}
		}

		$scope.bookCandidate = function (cand) {
			return ApiSvc.exec(
				$scope, 'call/NetClientCreateBooking',
				{
					pPersonID: cand.PersonID,
					pLineID: $scope.activeRequirement.RowID,
					pIsShift: $scope.activeRequirement.IsShift
				})
				.then(function (res) {
					FormSvc.alert('Candidate Booked', 'The candidate has been booked for this shift', 'success')
					$scope.filterRequirements()
					return $scope.refreshShortList()
				})
		}

		$scope.viewRequirementDetails = function (req) {
			$scope.selectedRow = req.RowID
			$scope.activeRequirement = req
			/* This is to view the list of requirements when page first loads. */
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetClientRequirementShortList?pRowID=' + req.RowID + '&IsShift=' + req.IsShift,
					fetchTarget: 'ShortListed',
					multiRow: true
				}
			)
				.then(function () {
					return ApiSvc.fetch(
						$scope,
						{
							fetchAPI: 'callresult/NetClientRequirementShortListPlaced?pRowID=' + req.RowID + '&IsShift=' + req.IsShift + '&IsCurrent=Y',
							fetchTarget: 'PlacedCandidates',
							multiRow: true
						}
					)
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/NetClientRequirementVerifiedCandidates?pRowID=' + $scope.activeRequirement.RowID + '&IsShift=' + $scope.activeRequirement.IsShift,
									fetchTarget: 'PreviousCandidates',
									multiRow: true
								}
							)
						})
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/NetClientRequirementSiteDetails?pRowID=' + $scope.activeRequirement.RowID + '&pIsShift=' + $scope.activeRequirement.IsShift,
									fetchTarget: 'SiteDetails',
									multiRow: false
								}
							)
						})
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/NetClientRequirementDocuments?pVacancyID=' + $scope.SiteDetails.VacancyID,
									fetchTarget: 'Documents',
									dateFields: ['LastUpdate'],
									multiRow: true
								}
							)
						})
						.then(function () {
							return ApiSvc.fetch(
								$scope,
								{
									fetchAPI: 'callresult/netuploadtypes?pOwnerType=V',
									fetchTarget: 'uploadTypes',
									multiRow: true
								}
							)
						})
						.then(function () {
							$scope.saveButtonCaption = "Save site details"

							return FormSvc.modalInfo($scope, 'CurrentRequirementsView', {
								requirement: req,
								sitedetails: $scope.SiteDetails,
								Documents: $scope.Documents,
								choices: [{ desc: "Close", type: "primary", code: '' }]
							}, 'xl')
						})
						.then(function () {
							$scope.selectedRow = null
						})
				})
		}

		$scope.saveSiteDetails = function (form) {
			let formFields = {
				pRole: form.theForm.Role.$modelValue,
				pSiteName: form.theForm.SiteName.$modelValue,
				pSiteContact: form.theForm.SiteContact.$modelValue,
				paddr1: form.theForm.addr1.$modelValue,
				paddr2: form.theForm.addr2.$modelValue,
				paddr3: form.theForm.addr3.$modelValue,
				ptown: form.theForm.town.$modelValue,
				pcounty: form.theForm.county.$modelValue,
				pcountry: form.theForm.country.$modelValue,
				ppostcode: form.theForm.postcode.$modelValue,
				pSitePhoneNumbers: form.theForm.SitePhoneNumbers.$modelValue,
				pSiteFax: form.theForm.SiteFax.$modelValue,
				pSiteEmail: form.theForm.SiteEmail.$modelValue,
				pVacancyID: $scope.SiteDetails.VacancyID
			}

			return ApiSvc.exec($scope, 'call/NetClientRequirementSiteDetailsUpdate', formFields)
				.then(function (res) {
					$scope.filterRequirements()
					return FormSvc.alert('', 'Site Details Updated', 'success')
				})
		}

		$scope.updateType = function () {
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetClientShiftDetailsTemplates?pVacancyID=' + $scope.typrequirementsObj.reqes,
					fetchTarget: 'shiftTemplates',
					multiRow: true,
					timeFields: ['TimeFrom', 'TimeTo'],
					numberFields: ['BreakMinutes'],
					booleanFields: ['Moveable']
				}
			)
				.then(function () {
					switch ($scope.selects.requirements.VacType) {
						case 'SV':
							$scope.isSV = true
							$scope.isCV = false
							$scope.isPV = false
							break

						case 'PV':
							if ($scope.currentRequirements.length > 1) {
								$scope.currentRequirements = [{}]
								$scope.updateType()
							}

							$scope.isCV = true
							$scope.isPV = true
							$scope.isSV = false
							/* Update Fields */
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].from = moment($scope.selects.requirements.DateFrom, 'DD/MM/YYYY').toDate()
							if ($scope.selects.requirements.DateTo == "") {
								$scope.currentRequirements[($scope.currentRequirements.length - 1)].to = moment().toDate("DD/MM/YYYY")
							} else {
								$scope.currentRequirements[($scope.currentRequirements.length - 1)].to = moment($scope.selects.requirements.DateTo, 'DD/MM/YYYY').toDate()
							}
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].position = $scope.selects.requirements.Position
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].reference = $scope.selects.requirements.reference
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].VacType = $scope.selects.requirements.VacType
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].VacancyID = $scope.selects.requirements.VacancyID
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].description = $scope.selects.requirements.Description
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].qty = parseInt(1)
							break
					}
				})
		}

		$scope.updateTypeContract = function () {
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetClientShiftDetailsTemplates?pVacancyID=' + $scope.selects.requirements.VacancyID,
					fetchTarget: 'shiftTemplates',
					multiRow: true
				}
			)
				.then(function () {
					switch ($scope.selects.requirements.VacType) {
						case 'SV':
							$scope.isSV = true
							$scope.isCV = false
							$scope.isPV = false
							break

						case 'CV':
							if ($scope.currentRequirements.length > 1) {

								SweetAlert.swal({
									title: "Shift type changed",
									text: "If you continue you will lose your current shifts.",
									type: "warning",
									showCancelButton: true,
									confirmButtonColor: "#DD6B55",
									confirmButtonText: "Ok, Continue"
								}).then(function (result) {
									if (!result.dismiss) {
										$scope.currentRequirements = [{}]
									} else {
										$scope.selects.requirements = $scope.selects.$requirements
									}
									$scope.updateType() // do an update again, to make sure all the vars are set correctly.
								})
							}

							$scope.isCV = true
							$scope.isPV = false
							$scope.isSV = false
							/* Update Fields */
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].from = moment($scope.selects.requirements.DateFrom, 'DD/MM/YYYY').toDate()
							if ($scope.selects.requirements.DateTo == "") {
								$scope.currentRequirements[($scope.currentRequirements.length - 1)].to = moment().toDate("DD/MM/YYYY")
							} else {
								$scope.currentRequirements[($scope.currentRequirements.length - 1)].to = moment($scope.selects.requirements.DateTo, 'DD/MM/YYYY').toDate()
							}
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].position = $scope.selects.requirements.Position
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].reference = $scope.selects.requirements.reference
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].VacType = $scope.selects.requirements.VacType
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].VacancyID = $scope.selects.requirements.VacancyID
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].description = $scope.selects.requirements.Description
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].qty = parseInt(1)
							break

						case 'PV':
							if ($scope.currentRequirements.length > 1) {


								SweetAlert.swal({
									title: "Shift type changed",
									text: "If you continue you will lose your current shifts.",
									type: "warning",
									showCancelButton: true,
									confirmButtonColor: "#DD6B55",
									confirmButtonText: "Ok, Continue"
								}).then(function (result) {
									if (!result.dismiss) {
										$scope.currentRequirements = [{}]
									} else {
										$scope.selects.requirements = $scope.selects.$requirements
									}
									$scope.updateType() // do an update again, to make sure all the vars are set correctly.
								})
							}

							$scope.isCV = true
							$scope.isPV = true
							$scope.isSV = false
							/* Update Fields */
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].from = moment($scope.selects.requirements.DateFrom, 'DD/MM/YYYY').toDate()
							if ($scope.selects.requirements.DateTo == "") {
								$scope.currentRequirements[($scope.currentRequirements.length - 1)].to = moment().toDate("DD/MM/YYYY")
							} else {
								$scope.currentRequirements[($scope.currentRequirements.length - 1)].to = moment($scope.selects.requirements.DateTo, 'DD/MM/YYYY').toDate()
							}
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].position = $scope.selects.requirements.Position
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].reference = $scope.selects.requirements.reference
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].VacType = $scope.selects.requirements.VacType
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].VacancyID = $scope.selects.requirements.VacancyID
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].description = $scope.selects.requirements.Description
							$scope.currentRequirements[($scope.currentRequirements.length - 1)].qty = parseInt(1)
							break
					}
				})
		}

		$scope.resetForm = function () {
			$scope.requirementAdded = false
			$scope.selects = {}
			$scope.currentRequirements = []
			$scope.shiftTemplates = []
			$scope.selects = []
			$scope.isSV = false
			$scope.isCV = false
			$scope.isPV = false
			$scope.currentRequirements.push({
				'date': '',
				'type': '',
				'from': '',
				'to': '',
				'break': '',
				'qty': '',
				'note': '',
				'ref': '',
				'added': false
			})
			$scope.isBulk = false
		}

		$scope.updateFields = function () {
			angular.forEach($scope.currentRequirements, function (val, key2) {
				if (!$scope.currentRequirements[key2].added) {
					$scope.isDisabled = false
					var xfields = $scope.currentRequirements[key2].type

					/* Update Fields */
					$scope.currentRequirements[key2].date = moment($scope.selects.requirements.DateFrom, 'DD/MM/YYYY').toDate()
					if ($scope.checkDate($scope.currentRequirements[key2].date)) {
						// Ensure the date isnt a date in the past.
						$scope.currentRequirements[key2].date = moment().toDate()
					}

					$scope.currentRequirements[key2].from = moment(xfields.TimeFrom, 'HH:mm').toDate()
					$scope.currentRequirements[key2].to = moment(xfields.TimeTo, 'HH:mm').toDate()
					$scope.currentRequirements[key2].break = parseInt(xfields.BreakMinutes)
					$scope.currentRequirements[key2].qty = parseInt(1)

					if (xfields.Moveable != 1) {
						$scope.isDisabled = true
					}
				}
			})
		}

		$scope.sendPerm = function () {
			var xData = $scope.currentRequirements[0]
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'call/NetClientAddVacancies?ptemplatevacancyid=' + xData.VacancyID + '&pdatefrom=' + moment(xData.from).format("DD/MM/YYYY") + '&pdateto=' + moment(xData.to).format("DD/MM/YYYY") + '&pTheirRef=' + encodeURIComponent(xData.reference) + '&pTitle=' + encodeURIComponent(xData.position) + '&pDescription=' + encodeURIComponent(xData.description) + '&pquantity=' + xData.qty,
					fetchTarget: 'insertPermVac',
					multiRow: false
				}
			)
				.then(function (rtrn) {
					FormSvc.alert("Added", "The requirement has been added.", "success")
					$scope.getRequirements()
						.then(function () {
							$scope.getFilters()
								.then(function () {
									$scope.filterLoaded = false
									$scope.filterRequirements()
									$scope.getOrderReasons()
								})
								.then(function () {
									if ($routeParams.openReq > 0) {
										$scope.viewRequirementDetails($routeParams)
									}
								})
						})
				})
				.catch(function (err) {
					if (err && err != "escape key press" && err != 'backdrop click') { FormSvc.alert("Error", err, "error") }
				})
		}

		$scope.sendShifts = function (addAnother) {
			var addAnother = addAnother || false

			// check that requirement is selected
			if (!$scope.typrequirementsObj) {
				FormSvc.alert("Missing requirement", "Please ensure that you have selected a requirement.", "error")
				return false
			}

			// check that refrence is selected
			if (!$scope.requirementsObj.ref && $scope.useRefInsteadOfQty != true) {
				FormSvc.alert("Missing reference", "Please ensure that you have selected a reference.", "error")
				return false
			}
			// check that reason is selected
			if (!$scope.requirementsObj.reason) {
				FormSvc.alert("Missing reason", "Please ensure that you have selected a reason.", "error")
				return false
			}

			var reason = $scope.requirementsObj.reason
			if (!$scope.useRefInsteadOfQty) {
				var ref = $scope.requirementsObj.ref
			}

			//  delete any that have not been set as "entry", and check that they are all valid
			angular.forEach($scope.currentRequirements, function (val, key) {
				if (!$scope.currentRequirements[key].entry) {
					delete $scope.currentRequirements[key]
				}
			})

			var validationFailed = false

			// check each shift has required fields
			angular.forEach($scope.currentRequirements, function (val, key) {
				if (!$scope.currentRequirements[key].date) {
					FormSvc.alert("Missing date", "Please ensure that all shifts have a date.", "error")
					validationFailed = true
				} else if (!$scope.currentRequirements[key].type) {
					FormSvc.alert("Missing type", "Please ensure that all shifts have a type.", "error")
					validationFailed = true
				} else if (!$scope.currentRequirements[key].from) {
					FormSvc.alert("Missing time", "Please ensure that all shifts have a start time.", "error")
					validationFailed = true
				} else if (!$scope.currentRequirements[key].to) {
					FormSvc.alert("Missing time", "Please ensure that all shifts have a finish time.", "error")
					validationFailed = true
				} else if (isNaN(parseFloat($scope.currentRequirements[key].break)) && !isFinite($scope.currentRequirements[key].break)) {
					if ($scope.currentRequirements[key].break < 0) {
						FormSvc.alert("Missing break", "Please ensure that all shifts have a break (minutes).", "error")
						validationFailed = true
					}
				} else if (!$scope.currentRequirements[key].qty && $scope.useRefInsteadOfQty != true) {
					FormSvc.alert("Missing quantity", "Please ensure that all shifts have a quantity.", "error")
					validationFailed = true
				}
			})

			if (validationFailed) {
				return false;
			}

			var counter = 1
			$scope.sendString = ''
			angular.forEach($scope.currentRequirements, function (val, key) {
				if (val.qty != 0 || $scope.useRefInsteadOfQty) {
					$scope.sendString += $scope.typrequirementsObj.reqes + '|' +
						val.type + '|' +
						encodeURIComponent(moment(val.date).format("YYYY-MM-DD")) + '|' +
						encodeURIComponent(moment(val.from).format("HH:mm")) + '|' +
						encodeURIComponent(moment(val.to).format("HH:mm")) + '|' +
						(val.qty ? val.qty : 1) + '|' +
						reason.value + '|' +
						($scope.useRefInsteadOfQty ? val.ref : (ref ? encodeURIComponent(ref) : '')) + '|' +
						(val.note ? encodeURIComponent(val.note) : '') + '|' +
						val.break

					if (counter != ($scope.currentRequirements.length)) {
						$scope.sendString += '*'
					}
				}
				counter++
			})
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'call/NetClientAddMultipleShifts?pParamList=' + $scope.sendString,
					fetchTarget: 'insertShift',
					multiRow: false
				}
			)
				.then(function () {
					FormSvc.alert("Added", "Your shifts have been added to the current requirements.", "success")
					$scope.toggleAddBulkShifts = addAnother
					$scope.requirementsObj = [{
						'entry': '1'
					}]
					$scope.getRequirements()
						.then(function () {
							$scope.getFilters()
								.then(function () {
									$scope.filterLoaded = false
									$scope.filterRequirements()
									$scope.getOrderReasons()
								})
								.then(function () {
									if ($routeParams.openReq > 0) {
										$scope.viewRequirementDetails($routeParams)
									}
								})
						})
				})
				.catch(function (err) {
					if (err && err != "escape key press" && err != 'backdrop click') { FormSvc.alert("Error", err.iqxError.text, "error") }
				})
		}

		$scope.submitForm = function () {
			if ($scope.currentRequirements[0].VacType == "CV" || $scope.currentRequirements[0].VacType == "PV") {
				$scope.sendPerm()
			} else {
				$scope.sendShifts()
			}
			$scope.resetForm()
		}

		$scope.showAddShiftModal = function (isDupe) {
			if (isDupe) {
				angular.forEach($scope.currentRequirements, function (val, key) {
					if (!$scope.currentRequirements[key].added) {
						$scope.remove(key)
					}
				})
			}
			$scope.selects.$requirements = $scope.selects.requirements
			FormSvc.modalForm($scope, 'addRequirement', $scope.currentRequirements, 'md', { label: 'col-sm-2', data: 'col-sm-10' })
				.then(function (data) {
					if (moment(data[0]['to']).isBefore(moment(data[0]['from']))) {
						throw "The to date is before the from date."
					}
					if (undefined !== data[0].from) {
						if ($scope.selects.requirements.VacType == 'CV' || $scope.selects.requirements.VacType == 'PV') { // perm
							$scope.submitForm()
						} else { // shift
							$scope.requirementAdded = true
							$scope.addNew(data)
						}
					} else {
						FormSvc.alert("Error", "You must select a vacancy.", "error")
					}

				})
				.catch(function (err) {
					if (typeof err === 'undefined' || err === 'escape key press' || err === 'backdrop click') { // Escape Key pressed!
						$scope.resetForm()
					} else if (err) {
						FormSvc.alert("Error", err, "error")
					}
				})
		}

		$scope.addNew = function (requirement) {
			angular.forEach($scope.currentRequirements, function (val, key) {
				$scope.currentRequirements[key]['added'] = true
				$scope.currentRequirements[key]['prettyDate'] = moment($scope.currentRequirements[key].date).format("DD/MM/YYYY")
				$scope.currentRequirements[key]['prettyTimeFrom'] = moment($scope.currentRequirements[key].from).format("HH:mm")
				$scope.currentRequirements[key]['prettyTimeTo'] = moment($scope.currentRequirements[key].to).format("HH:mm")
			})

			$scope.currentRequirements.push({
				'date': '',
				'type': '',
				'from': '',
				'to': '',
				'break': '',
				'qty': '',
				'note': $scope.currentRequirements[($scope.currentRequirements.length - 1)].note,
				'ref': $scope.currentRequirements[($scope.currentRequirements.length - 1)].ref,
				'added': false
			})
		}

		$scope.remove = function (key) {
			// Delete from the shift list
			delete $scope.currentRequirements[key]
			$scope.currentRequirements.splice(key, 1)

			// CHeck to make sure there is atleast one blank element to create new ones
			if ($scope.currentRequirements.length == 0 || !$scope.currentRequirements) {
				$scope.currentRequirements.push({
					'date': '',
					'type': '',
					'from': '',
					'to': '',
					'break': '',
					'qty': '',
					'note': $scope.currentRequirements[($scope.currentRequirements.length - 1)].note,
					'ref': $scope.currentRequirements[($scope.currentRequirements.length - 1)].ref,
					'added': false
				})
			}
		}

		$scope.checkDate = function (date) {
			if (moment().diff(date, 'days') > 0) {
				return true
			} else {
				return false
			}
		}

		$scope.getRequirements = function () {
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetClientCombinedRequirementTemplates',
					fetchTarget: 'requirementSelectBox',
					multiRow: true
				}
			)
				.then(function () {
					$scope.selects.requirements = $scope.requirementSelectBox
					$scope.showAddShiftReqBtn = false
					$scope.showAddContractReqBtn = false

					$scope.showAddShiftReqBtn = $scope.requirementSelectBox.reduce(function (n, req) {
						return n + (req.VacType == 'SV')
					}, 0)

					$scope.showAddContractReqBtn = $scope.requirementSelectBox.reduce(function (n, req) {
						return n + (req.VacType == 'CV')
					}, 0)

					$scope.getOrderReasons()
				})
		}

		$scope.duplicateModal = function (key) {
			return FormSvc.modalInfo($scope, 'duplicateModal', { key: parseInt(key), choices: [{ desc: "Close", type: "primary", code: '' }] }, 'md')
		}

		$scope.getOrderReasons = function () {
			return ApiSvc.fetch(
				$scope,
				{
					fetchAPI: 'callresult/NetClientShiftOrderReasons',
					fetchTarget: 'OrderReasons',
					multiRow: true
				}
			)
				.then(function () {
					$scope.selects.OrderReason = $scope.NetClientShiftOrderReasons
				})
		}

		$scope.getRequirements()
			.then(function () {
				$scope.getFilters()
					.then(function () {
						$scope.filterLoaded = false
						$scope.filterRequirements()
						$scope.getOrderReasons()
					})
					.then(function () {
						if ($routeParams.openReq > 0) {
							$scope.viewRequirementDetails($routeParams)
						}
					})
			})
	})
